import { DEFAULT_ADDRESS_VALUE, SEPARATOR_DEFAULT_ADDRESS_VALUE } from '../../../modules/order-builder/modules/location/constants/default-address-value.constants';

 /**
     * Function to validate in case exists default address value then remove this text 'ASK FOR LOCATION'
     * @param valueField value to evaluate
     * @returns value to display
     */
 export function removeDefaultAddressValue(valueField: string): string {
  // Some fields could has complete or incomplete ' - ASK FOR LOCATION' text
  const valueToEvaluateSubstring = !!valueField && valueField.includes(DEFAULT_ADDRESS_VALUE)
      ? DEFAULT_ADDRESS_VALUE
      : SEPARATOR_DEFAULT_ADDRESS_VALUE;
  return !!valueField && valueField.includes(valueToEvaluateSubstring)
      ? valueField.substring(0, valueField.indexOf(valueToEvaluateSubstring))
      : valueField;
}
